/**
 * Add 'ariaToggle', 'ariaShow' and 'ariaHide' plugins.
 */
export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  let initialized = false;

  const toggleAria = (element, show) => {
    if (show == null) {
      show = !$(element).is(':visible');
    }

    if (show) {
      $(this).removeAttr('aria-hidden');
    }
    else {
      $(this).attr('aria-hidden', 'true');
    }
  };

  return () => {
    if (initialized) {
      return;
    }

    initialized = true;
    
    ['toggle', 'show', 'hide'].forEach(name => {
      const orig = $.fn[name];
      const ariaName = 'aria' + name.substr(0, 1).toUpperCase() + name.substr(1);
      
      $.fn[ariaName] = function() {
        if (name === 'show' || name === 'hide') {
          if (name === 'show') {
            $(this).removeAttr('aria-hidden');
          }
          else {
            $(this).attr('aria-hidden', 'true');
          }
  
          return orig.apply(this, arguments);
        }
  
        // toggle
        if (typeof arguments[0] === 'boolean') {
          $(this).each(function() {
            toggleAria(this, arguments[0]);
          });
  
          return orig.apply(this, arguments);
        }
        else {
          $(this).each(function() {
            toggleAria(this);
          });
  
          return orig.apply(this, arguments);
        }
      };
    });
  };
})(jQuery, window);